export default {
  namespaced: true,
  state: {
    creditCardFormData: {
      cardholder_name: '',
      card_expiry: '',
      card_cvc: '',
    },
    creditCardFormErrors: {
      cardholder_name: false,
      card_expiry: false,
      card_cvc: false,
      card_number: false,
    },
    achFormData: {
      ach_name: '',
      ach_routing: '',
    },
    achFormErrors: {
      ach_name: false,
      ach_routing: false,
    },
    billingAddressRequiredFields: [
      'address_line_1',
      'city',
      'state',
      'zip',
      'country',
    ],
    billingAddressFormData: {
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
    },
    billingAddressFormErrors: {
      address_line_1: false,
      address_line_2: false,
      city: false,
      state: false,
      zip: false,
      country: false,
    }
  },
  mutations: {
    setBillingAddressFormData(state, { field, value }) {
      state.billingAddressFormData[field] = value
      state.billingAddressFormErrors[field] = false
    },
    setBillingAddressFormError(state, { field, value }) {
      state.billingAddressFormErrors[field] = value
    },
    resetBillingAddressForm(state) {
      for (let key in state.billingAddressFormData) state.billingAddressFormData[key] = ''
      for (let key in state.billingAddressFormErrors) state.billingAddressFormErrors[key] = false
    },
    setCreditCardFormData(state, { field, value }) {
      state.creditCardFormData[field] = value
      state.creditCardFormErrors[field] = false
    },
    setCreditCardFormError(state, { field, value }) {
      state.creditCardFormErrors[field] = value
    },
    resetCreditCardFormData(state) {
      for (let key in state.creditCardFormData) state.creditCardFormData[key] = ''
      for (let key in state.creditCardFormErrors) state.creditCardFormErrors[key] = false
    },
    setACHFormData(state, { field, value }) {
      state.achFormData[field] = value
      state.achFormErrors[field] = false
    },
    setACHFormError(state, { field, value }) {
      state.achFormErrors[field] = value
    },
    resetACHFormData(state) {
      for (let key in state.achFormData) state.achFormData[key] = ''
      for (let key in state.achFormErrors) state.achFormErrors[key] = false
    },
    resetAllErrors(state) {
      for (let key in state.billingAddressFormErrors) state.billingAddressFormErrors[key] = false
      for (let key in state.creditCardFormErrors) state.creditCardFormErrors[key] = false
      for (let key in state.achFormErrors) state.achFormErrors[key] = false
    },
  },
  getters: {
    getCreditCardField: (state) => (field) => {
      return state.creditCardFormData[field] || ''
    },
    getCreditCardFormErrors: (state) => {
      return state.creditCardFormErrors
    },
    getCreditCardError: (state) => (field) => {
      return state.creditCardFormErrors[field] || false
    },
    getACHField: (state) => (field) => {
      return state.achFormData[field] || ''
    },
    getACHFormErrors: (state) => {
      return state.achFormErrors
    },
    getACHError: (state) => (field) => {
      return state.achFormErrors[field] || false
    },
    getBillingAddressRequiredFields: (state) => {
      return state.billingAddressRequiredFields
    },
    getBillingAddressFormData: (state) => {
      return state.billingAddressFormData
    },
    getBillingAddressField: (state) => (field) => {
      return state.billingAddressFormData[field] || ''
    },
    getBillingAddressFormErrors: (state) => {
      return state.billingAddressFormErrors
    },
    getBillingAddressError: (state) => (field) => {
      return state.billingAddressFormErrors[field] || false
    },
  },
  actions: {
    validateCardknoxExpiry(store, raw) {
      const value = raw?.trim()
      if (!value) return true

      const [monthStr, yearStr] = value.split('/')
      const month = parseInt(monthStr, 10)
      let year = parseInt(yearStr, 10)

      if (!month || !yearStr || yearStr.length !== 2) return 'invalid_format'
      if (month < 1 || month > 12) return 'invalid_month'

      const currentYear = new Date().getFullYear()
      const century = Math.floor(currentYear / 100) * 100
      year = century + year

      const expiryDate = new Date(year, month - 1)
      const now = new Date()
      now.setDate(1)

      if (expiryDate < now) return 'expired'

      return false
    },
  },
}